module.exports = __webpack_public_path__ + "static/media/background.533a4879.jpg";